import React from "react";
import { Modal as AntModal } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

const CustomModal = styled(AntModal)`
  & .ant-modal-header {
    background-color: #d3e8ff;
    border-width: 0px;
    padding: 22px 24px;
  }
  & .ant-modal-title {
    color: #1070b6;
    font-size: 24px;
    font-weight: bold;
  }
  & .ant-modal-close {
    margin-right: 24px;
    margin-top: 16px;
  }
  & .ant-modal-close-x {
    height: auto;
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  & .ant-modal-body {
    padding: 16px 24px;
    font-size: 15px;
  }
  & .ant-modal-close-x svg {
    transform: scaleY(1.1);
  }
  &.ant-modal {
    width: ${(props) => props.style?.width || "380px !important"};
  }
`;

const Modal = ({
  title,
  visible,
  onCancel,
  children,
  modalWidth,
  ...rest
}: any) => (
  <CustomModal
    title={title}
    centered
    closeIcon={
      <FontAwesomeIcon
        icon={faWindowClose as IconProp}
        className="question-icon"
        size="2x"
      />
    }
    style={{ width: modalWidth }}
    visible={visible}
    onCancel={onCancel}
    footer={null}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
  >
    {children}
  </CustomModal>
);

export default Modal;
